<form class="flex flex-col w-full overflow-auto" [formGroup]="heureTravailleeForm" (ngSubmit)="onFormSubmit()">
    <div class="" formArrayName="heures_travaillees">
        <div class="flex flex-row sm:flex-row pr-8 pl-8 pb-0 space-x-4" *ngFor="let heureTravailleControls of heuresTravailleesControlsArray; let i = index" [formGroupName]="i">
            <mat-form-field class="w-full">
                <mat-label>Technicien</mat-label>
                <mat-select formControlName="user_id" [compareWith]="compareUsersSelect" (selectionChange)="addHeureTravaille(null, i)">
                    <mat-option *ngFor="let user of users" [value]="user">{{user.prenom}} {{user.nom}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Date</mat-label>
                <input type="date" matInput formControlName="date" (change)="addHeureTravaille(null, i)">
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Heure de départ</mat-label>
                <input type="time" matInput formControlName="heure_depart" (change)="addHeureTravaille(null, i)">
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Heure de retour</mat-label>
                <input type="time" matInput formControlName="heure_retour" (change)="addHeureTravaille(null, i)">
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Diner</mat-label>
                <mat-select formControlName="diner" [compareWith]="compareDinerSelect">
                    <mat-option [value]="1">Oui</mat-option>
                    <mat-option [value]="0">Non</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- <mat-form-field class="w-full">
                <mat-label>Temps</mat-label>
                <mat-select formControlName="temps">
                    <mat-option [value]="'Temps régulier'">Temps régulier</mat-option>
                    <mat-option [value]="'Temps 1/2'">Temps 1/2</mat-option>
                </mat-select>
            </mat-form-field> -->
        </div>
    </div>

    <div class="flex items-center justify-between w-full border-t px-8 py-4">
        <div class="flex items-center">
            <div class="flex items-center mr-4">
                <ng-container *ngIf="success">
                    <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                    <span class="ml-2">Les heures travaillées ont été mises à jour</span>
                </ng-container>
                <ng-container *ngIf="error">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                </ng-container>
            </div>
            <button type="submit" mat-flat-button [color]="'primary'">Enregistrer</button>
        </div>
    </div>
</form>